import _ from "lodash";
import { create, all } from "mathjs";

// 扩展银行家舍入法
// console.log("================ 银行家舍入法测试 ========================")
// console.log(23.556, "->", bankToFixed(23.556))
// console.log(23.554, "->", bankToFixed(23.554))
// console.log(
//   "四舍六入五考虑，五后非零就进一",
//   23.5551,
//   "->",
//   bankToFixed(23.5551)
// )
// console.log(
//   "五后为零看奇偶，五前为偶应舍去，",
//   23.525,
//   "->",
//   bankToFixed(23.525)
// )
// console.log("五前为奇要进一", 23.555, "->", bankToFixed(23.555))
// console.log("================ 银行家舍入法测试 ========================")
export function bankToFixed(target, pos = 2, tofixed = true) {
  target = leftMove(target, pos);

  const res = math.compare(target, 0);
  const incI = res > 0 ? 1 : -1; // 进位值

  const strTarget = target.toString();
  let dotIndex = strTarget.indexOf(".");

  // 相关校验
  if (dotIndex == -1) {
    return rightMove(target, pos, tofixed);
  }
  let nextPos = dotIndex + 1;
  if (nextPos > strTarget.length) {
    return rightMove(target, pos, tofixed);
  }

  // ~~: 做两次按位取反的操作（和强制类型转换基本一样）
  let posNum = ~~strTarget[nextPos];
  if (posNum != 5) {
    if (posNum > 5) {
      return rightMove(math.add(trunc(target), incI), pos, tofixed);
    } else {
      return rightMove(trunc(target), pos, tofixed);
    }
  }

  // 查看后面的值是不是大于0，前面的算法保证了如果后面是0是不会显示的
  if (nextPos + 1 < strTarget.length) {
    return rightMove(math.add(trunc(target), incI), pos, tofixed);
  }
  // 校验奇偶
  if (Number(strTarget[nextPos - 2]) % 2 == 0) {
    return rightMove(trunc(target), pos, tofixed);
  } else {
    return rightMove(math.add(trunc(target), incI), pos, tofixed);
  }
}
// 左移位数
function leftMove(target, pos) {
  // return target * Math.pow(10, pos)
  return math.multiply(target, math.pow(10, pos));
}
// 右移位数
function rightMove(target, pos, tofixed) {
  // return (target / Math.pow(10, pos)).toFixed(pos)
  return tofixed
    ? math.format(math.divide(target, math.pow(10, pos)), {
        notation: "fixed",
        precision: pos,
      })
    : math.divide(target, math.pow(10, pos));
}
// 截断小数位
function trunc(target) {
  const res = math.compare(target, 0);
  if (res > 0) {
    // 向下取整
    return math.floor(target);
  } else {
    // 向上取整
    return math.ceil(target);
  }
}

const origMath = create(all, {
  // 用于检验两者相等性的最小相对差 比较值。
  // 所有关系函数都使用此值。 默认值为 。1e-12
  epsilon: 1e-60,
  // 函数的默认矩阵输出类型。
  matrix: "Matrix",
  // 函数的数字输出类型，无法从输入中确定数字类型。
  // 但是对于大多数函数，输出的类型是根据输入确定的：作为输入的数字将返回一个数字作为输出，BigNumber作为输入返回BigNumber作为输出。
  number: "BigNumber",
  // BigNumbers的最大有效位数。此设置仅适用于BigNumbers，而不适用于数字。默认值是64。
  precision: 64,
  // 可预测的输出类型的函数。
  // 如果为 true，则输出类型 仅取决于输入类型。
  // 如果为 false（默认值），则输出类型可能会有所不同 取决于输入值。
  predictable: false,
  // 将此选项设置为种子伪随机数生成，使其成为确定性的。
  randomSeed: null,
});

export const math = {
  ...origMath,

  _bignumber: origMath.bignumber,
  bignumber: function (x) {
    if (!math._bignumber) {
      return origMath.bignumber(null);
    }
    const X = Number(x);
    if (_.isNaN(X) || !_.isNumber(X)) {
      return origMath.bignumber(null);
    }
    // 兼容清册不规范数据
    if (x === "" || x === "- -" || x === "— —") {
      return origMath.bignumber(null);
    }

    return math._bignumber(x);
  },

  _format: origMath.format,
  format: function (value, options) {
    if (!math._format) {
      return "";
    }
    const defOptions = { notation: "fixed", precision: 2 };

    if (options) {
      // value = math._format(value, options, callback)
      // return (value = bankToFixed(value, 2))
      if (!_.isNumber(options) && !_.isFunction(options)) {
        if (options.isBankToFixed === true) {
          options = { ...defOptions, ...options };
          // options.precision = (options.precision || 2) + 2

          value = bankToFixed(value, options.precision, false);
        }
        return math._format(value, options);
      }
      return math._format(value, options);
    } else {
      return math._format(value, defOptions);
    }
  },

  compareBigNumber: function (x, y) {
    // 可能传入的数据类型：number | BigNumber | string
    if (math.isNumber(x) && math.isNumber(y)) {
      return math.compare(x, y);
    } else if (math.isBigNumber(x) || math.isBigNumber(y)) {
      return math.number(math.compare(x, y));
    } else {
      return math.compare(x, y);
    }
  },
};

export default math;
